import axios from 'axios';
import Globals from '../Globals';
import LoggingService from './LoggingService';
import { getLogModel } from '../Functions';

class SellService {
    base_url = Globals.BFF_PATH.BASE_URL + Globals.BFF_PATH.SELL.BASE_PATH;

    buyVehicle = async (object, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.SELL.BUY_VEHICLE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    buyVehicleDealerReceptor = async (object, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.SELL.BUY_VEHICLE_RECEPTOR,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    dumpVehicles = async (data, token, awsUrl, apiKeyName, apiKeyValue) => {
        var headers = {
            Authorization: `Bearer ${token}`,
        };
        headers[apiKeyName] = apiKeyValue;
        var config = {
            headers: headers,
        };
        return await axios
            .post(awsUrl, data, config)
            .then(response => {
                //data = "OK" status = 200
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getBuyers = async (token, employeeId) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(employeeId),
        };

        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.SELL.GET_BUYERS,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    rejectVehicle = async (object, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.SELL.REJECT_VEHICLE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    negotiateVehicle = async (object, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.SELL.NEGOTIATE_VEHICLE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    insertExportOffer = async (object, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.SELL.OFFER_VEHICLE,
                data,
                config
            )
            .then(response => {
                if (response?.data?.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    getBillVehicle = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(this.base_url + Globals.BFF_PATH.SELL.GET_BILL, data, config)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    updatePickupDate = async (object, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.SELL.UPDATE_PICKUP_DATE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    sendEmailDeliveryCertificate = async (object, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.SELL.SEND_DELIVERY_CERTIFICATE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    getBillVehicleSoldVWR = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(this.base_url + Globals.BFF_PATH.SELL.GET_BILL_VWR, data, config)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getDocumentsForSale = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(this.base_url + Globals.BFF_PATH.SELL.GET_DOCUMENTS_FOR_SALE, data, config)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getDocumentForSaleById = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(this.base_url + Globals.BFF_PATH.SELL.GET_DOCUMENT_FOR_SALE_BY_ID, data, config)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };
}

export default SellService;
